// Turni ufficiali (Europe/Rome, ora locale del dispositivo)
// - Turno I  → 06:00 – 14:00
// - Turno II → 14:00 – 22:00
// - Turno III → 22:00 – 06:00 (giorno successivo)
export const SHIFTS = [
    { value: "I",   label: "I · 6–14",  start: 6,  end: 14 },
    { value: "II",  label: "II · 14–22", start: 14, end: 22 },
    { value: "III", label: "III · 22–6", start: 22, end: 6  }, // wrap
];

export const SHIFT_LABEL = SHIFTS.reduce((acc, s) => (acc[s.value] = s.label, acc), {});

// Ritorna 'I' | 'II' | 'III' in base all'ora locale, con "cortesia" ai cambi turno:
//   05:00–06:59  → I  (chi entra un po' prima delle 6)
//   13:00–14:59  → II
//   21:00–22:59  → III
// Altrimenti: I=6–13, II=14–21, III=22–5.
export function shiftAt(date = new Date()) {
    const h = date.getHours();
    if (h >= 5 && h < 7)   return "I";
    if (h >= 13 && h < 15) return "II";
    if (h >= 21 && h < 23) return "III";
    if (h >= 7 && h < 13)  return "I";
    if (h >= 15 && h < 21) return "II";
    return "III"; // 23:00–04:59
}
